<!--@description 封装全局购物车弹窗
    @author cc
    @date 2020-3-12
  -->
<template>
  <div>
    <cc-bottom-popup
      v-bind="$attrs"
      v-on="$listeners"
      @subBtn="subBtn"
      @closeCallback="closeCallback"
      :autoHeight="true"
      :subText="cartItemData.type==8?'支付定金':'确定'"
      :region="cartItemData.region"
    >
      <template slot="header" class="header">
        <div class="header-img">
          <img :src="cartItemData.showimage" alt />
        </div>
        <div class="cart-con-header-info ml15 mb20 mr10">
          <p>
            <span class="mr5">{{cartItemData.general_name}}</span>
            <span>{{cartItemData.norms}}</span>
          </p>
          <!-- 多批号 -->
          <p v-if="cartItemData.is_batch_number&&cartItemData.is_batch_number==1">
          <span>{{isNaN(cartItemData.priceBatch)?'':'￥'}}</span>
          <span :class="isNaN(cartItemData.priceBatch)?'f15':'f18'">{{float_change(cartItemData.priceBatch)}}</span>
          </p>
          <p v-else>
            <span>{{isNaN(cartItemData.jiage)?'':'￥'}}</span>
            <span :class="isNaN(cartItemData.jiage)?'f15':'f18'">{{float_change(cartItemData.jiage)}}</span>
          </p>
        </div>
      </template>
      <div class="cart-con-center">
        <div>
          <p class="cart-con-center-line">
            <span class="bold" >选择批号：</span>
          </p>
          <p>
            <span
              v-if="cartItemData.is_batch_number==0"
              class="kind active"
            >{{cartItemData.batch_code}}</span>
            <!-- 多批号 -->
            <span
              v-else-if="cartItemData.is_batch_number==1"
              v-for="(ele,index) in cartItemData.data"
              :key="index"
              class="kind"
              :class="activeBatch==index? 'active':'default'"
              @click="selectBatch(index,ele)"
            >{{ele.batch_code}}</span>
            <!-- 多批号被地区限制了 -->
            <span
              v-if="cartItemData.region==1"
              class="kind default"
            >暂无批号</span>
          </p>
        </div>
        <div>
          <p class="cart-con-center-line">
            <span class="bold">选择单位：</span>
          </p>
          <p>
            <!-- 没有包装规格(无中包装) -->
            <span class="kind active" v-if="cartItemData.pack && cartItemData.pack.length==0&&cartItemData.unit">{{cartItemData.unit}}</span>
            <!-- 开启多批号购买 同步多批号中包装时 -->
            <span style="width:50px;color:#E2E0E0"  class="kind default" v-if="cartItemData.pack=='无'">无</span>
            <!-- 有包装规格 （有中包装）&& 不可拆销-->
            <span
              v-else-if="cartItemData.pack && cartItemData.pack.length>0&&cartItemData.is_real_separate*1===0"
              class="kind"
              :class="active==index?'active':'default'"
              @click="changPack(index,ele.num) "
              v-for="(ele ,index) in cartItemData.pack"
              :key="index"
            >{{ele.num+'/'+ele.units}}</span>
            <!-- 有包装规格 （有中包装）&& 可拆销-->
            <span
              v-else-if="cartItemData.pack && cartItemData.pack.length>0&&cartItemData.is_real_separate*1===1"
            >
              <span v-if="cartItemData.pack[0].is_pack=='off'">
                <span v-for="(ele ,index) in cartItemData.pack" :key="index">
                  <span
                    v-if="index==0"
                    class="kind default"
                    style="color:#E2E0E0;"
                  >{{ele.num+'/'+ele.units}}</span>
                  <span
                    v-else
                    class="kind"
                    :class="active1==index?'active':'default'"
                    @click="changPack(index,ele.num) "
                  >{{ele.num+'/'+ele.units}}</span>
                </span>
              </span>
              <span
                v-else
                class="kind"
                :class="active==index?'active':'default'"
                @click="changPack(index,ele.num) "
                v-for="(ele ,index) in cartItemData.pack"
                :key="index"
              >{{ele.num+'/'+ele.units}}</span>
            </span>
          </p>
        </div>
        <div>
          <p class="cart-con-center-line">
            <span class="bold">数量：</span>
            <span class="bold fr">
              <!-- 有多批号商品则选择多批号商品的库存 -->
              <cc-stepper-new
                :min="cartItemData.step"
                v-model="cartItemData.num"
                :step="cartItemData.step"
                :max="cartItemData.is_batch_number==0?cartItemData.max:cartItemData.stockBatch*1"
                :choose="cartItemData.choose"
                :judgeNornSure="cartItemData.judgeNornSure"
                style="height:0.260rem"
              ></cc-stepper-new>
            </span>
          </p>
        </div>
        <div>
          <p class="cart-con-center-line">
            <!-- <span class="fr" v-if="cartItemData.last_date"> -->
            <span>
              <span class="bold">有效期：</span>
              <!-- 多批号 -->
              <span v-if="cartItemData.is_batch_number==1">{{cartItemData.last_dateBatch}}</span>
              <span v-else>{{cartItemData.last_date}}</span>
            </span>
            <span class="fr">
              <span class="bold">库存：</span>
              <!-- 预售 -->
              <span v-if="cartItemData.type==8">{{cartItemData.presell_hide_stock}}</span>
              <!-- 多批号 -->
              <span v-else-if="cartItemData.is_batch_number*1===1">{{cartItemData.hidestockeBatch}}</span>
              <span v-else>{{cartItemData.hidestock || cartItemData.hide_stock}}</span>
            </span>
          </p>
        </div>
      </div>
    </cc-bottom-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import Command from '@/mixins/command'
import cartStep from '@/mixins/cartStep'

import { Toast, Dialog} from 'vant'
import { addtocartnew } from '@/fetch/common'
import { SessionStorage } from '@/utils'

Vue.use(Toast).use(Dialog)

export default {
  name: 'CcShopCart',
  mixins: [Command, cartStep],
  props: {
    cartItemData: {
      type: Object
    },
    // 是否重置购物弹窗重置的值
    resetval: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 高亮规格
      active: 0,
      // 高亮多批号
      activeBatch: 0,
      active1: 1

    }
  },
  created () {
  },
  methods: {
    /**
     * @description 加入购物车确实按键操作
     * @author cc
     * @date 2020-03-11
     * @param {data} item 商品
     */
    async subBtn () {
      if (this.cartItemData.type === 8) {
        // ============一、预售==============
        // 1.直接跳转到预售车页面
        if (+this.cartItemData.presell_stock) {
          const { cartItemData } = this
          SessionStorage.setItem('presell', {
            goods_id: cartItemData.id,
            presell_id: cartItemData.presell_id,
            payment_type: cartItemData.payment_type,
            quantity: cartItemData.num,
            is_presell: 1
          })
          this.$router.push('/shopping-cart/presell?path=' + this.$route.fullPath)
          // window.location =
          //   '/cart/index?goods_id=' +
          //   this.cartItemData.id +
          //   '&presell_id=' +
          //   this.cartItemData.presell_id +
          //   '&payment_type=' +
          //   this.cartItemData.payment_type +
          //   '&quantity=' +
          //   this.cartItemData.num +
          //   '&is_presell=1'
        }
        // 关闭弹窗
        this.$emit('close')
      } else {
        // ===========二、普通商品、多批号加入购物车===========
        // 包装规格是否有误
        var packRrrorRes = this.packRrror(this.cartItemData.choose, this.cartItemData.judgeNornSure)
        if (!packRrrorRes) {
          return false
        }
        let data = {
          type: this.cartItemData.for_type,
          goods_id: this.cartItemData.goods_id || this.cartItemData.id,
          quantity: this.cartItemData.num,
          for_id: this.cartItemData.for_type !== 1 ? this.cartItemData.for_id : '',
          batch_id: this.cartItemData.is_batch_number === 1 ? this.cartItemData.idBatch : '',
          remind: 0
        }
        let res = await addtocartnew(data)
        SessionStorage.setItem('hasNewGoods', '1')// 加入一个标识 通知购物车有新的商品加入，再次进入购物车重新请求
        if (res.status === 0 || res.status === 1) {
          this.showmsg(res)
        } else if (res.status === 2) {
          // 再次加入购物车提醒
          Dialog.confirm({
            message: res.info.msg,
            confirmButtonText: '添加'
          }).then(async () => {
            data.remind = 1// 再次加入购物车标识
            let res = await addtocartnew(data)
            this.showmsg(res)
          }).catch(() => {
            // 弹窗取消操作
          })
        }
      }
      this.active = 0
      this.activeBatch = 0
      this.active1 = 1
    },
    showmsg (res) {
      Toast(res.info.msg)
      this.cartGetnum()
      // 关闭弹窗
      this.$emit('close')
    },
    // 点击规格切换
    changPack (index, num) {
      this.cartItemData.num = num * 1
      this.cartItemData.step = num * 1
      this.active = index
      this.active1 = index
    },
    /**
     * @description 选择批号
     * @author cc
     * @date 2020-03-11
     * @param {index：商品索引,item:商品信息}
     */
    selectBatch (index, item) {
      this.$emit('batchVal', item.batch_code)
      this.activeBatch = index
      this.cartItemData.hidestockeBatch = item.hidestock
      this.cartItemData.priceBatch = item.price
      this.cartItemData.last_dateBatch = item.last_date
      this.cartItemData.stockBatch = item.stock
      this.cartItemData.idBatch = item.id
      // 同步中包装，并中包装中有值时,没值时显示：无
      if (item.pack !== null) {
        var obj = this.steps(
          this.cartItemData.choose,
          item.pack.goods_pack,
          item.pack.is_big_pack
        )
        if (obj) {
          if ((this.cartItemData.choose === 0 && obj.judgeNornSure === 0.001) || (this.cartItemData.choose === 1 && obj.judgeNornSure === 1)) {
            // 当包装规格有误时，步长为0
            item.step = 0
          } else {
            item.step = obj.num
          }
          item.num = obj.num
          this.cartItemData.pack = item.pack.goods_pack
          item.judgeNornSure = obj.judgeNornSure
        }
      } else {
        // 这里看下要区分整装和散装不
        item.num = this.cartItemData.choose ? 0.001 : 1
        item.step = item.num
        this.cartItemData.pack = '无'
        item.judgeNornSure = item.num
      }
      this.cartItemData.num = item.num
      this.cartItemData.step = item.step
    },
    closeCallback () {
      if (!this.resetval) {
        this.active = 0
        this.active1 = 1
        this.activeBatch = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.xpt-popup {
  .header {
    width: 100%;
    border-bottom: 1px solid #f2f2f2;
    box-sizing: border-box;
    padding: 10px 0 0 10px;
    display: flex;
    &-img {
      @include wh(63px, 63px);
      img {
        @include wh(63px, 63px);
        border-radius: 4px;
      }
    }
  }
  .bold {
    // font-weight: bold;
    color: #333333;
  }
  .c555 {
    color: #555555;
  }
  .cart-con {
    flex: 1;
    &-header {
      &-info {
        p:nth-child(1) {
          @include sc(15px, #333333);
          margin-bottom: 23.5px;
          padding-right: 20px;
        }
        p:nth-child(2) {
          @include sc(12px, #ed3838);
           span:nth-child(2){
             font-size: 18px;
          }
        }
      }
    }
    &-center {
      padding: 7px 10px 0 10px;
      box-sizing: border-box;
      &-line {
        font-size: 13px;
        line-height: 30px;
      }
      .fs10 {
        font-size: 10px;
      }
      .fs11.5 {
        font-size: 11.5px;
      }
      .kind {
        padding: 0 8px;
        height: 21px;
        border-radius: 10px;
        text-align: center;
        line-height: 21px;
        margin: 6px 26px 6px 0px;
        box-sizing: border-box;
        display: inline-block;
      }
      span{
        font-size: 12px;
      }
      .default {
        background: #f6f6f6;
        color: #555555;
        border: 1px solid #f6f6f6;
      }
      .active {
        border: 1px solid var(--APP_theme_color);
        color: var(--APP_theme_color);
        background: var(--APP_theme_color_colorOpacity1);
      }

    }
  }
}
</style>
